import React from "react";
import { Label } from "reactstrap";
import { SelectFilterYear, SelectPerusahaan } from "../../../component/Utils";
import { isBiro } from "../../../utils/helper";

const HeaderComp = ({ title }) => {
  return (
    <div className="card border-0 rounded-0">
      <div className="container py-4">
        <div className="row px-4">
          <div className="col-md-4 d-flex align-items-center ">
            <h3 className="mr-auto my-auto">{title}</h3>
          </div>
          <div className="col-md-8">
            <div className="row">
              <div className="col d-flex justify-content-end align-items-center mt-md-0 mt-3">
                {isBiro() && (
                  <div className="mr-3">
                    <Label className="mr-3">Perusahaan</Label>
                    <SelectPerusahaan default={true} />
                  </div>
                )}
                <div>
                  <Label className="mr-3">Tahun</Label>
                  <SelectFilterYear />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComp;
